import React, { useState, useCallback, useEffect } from "react";
import { notification, Flex } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useGetMuxAuthenticatedUrlMutation, useEditWorkoutMutation } from "store/api/api";
import MuxUploadAndVideoPlayer from "components/Forms/Workout/UploadAssetsForm.jsx/MuxUploadAndPlayer";
import { Button } from "components/Common/Button";

const PreRecordVideoUpload = ({ values, setValues, domainGymId, previousStep, nextStep, loading }) => {
	const [getMuxSignedUrlTrigger, muxSignedUrlResponse] = useGetMuxAuthenticatedUrlMutation();
	const [editWorkoutUploadIdTrigger] = useEditWorkoutMutation();

	const [uploadReady, setUploadReady] = useState(values.videoUploaded);

	const getMuxSignedUrl = useCallback(async () => {
		try {
			const { data, error } = await getMuxSignedUrlTrigger();
			if (error) {
				return notification.error("An error occurred getting Mux Upload signed URL");
			}
			await editWorkoutUploadIdTrigger({
				workout_id: values?.workout_id,
				gym_id: domainGymId,
				upload_id: data.id,
			});
		} catch (error) {
			console.debug("error", error);
		}
	}, [getMuxSignedUrlTrigger, editWorkoutUploadIdTrigger, values?.workout_id, domainGymId]);

	useEffect(() => {
		if (!uploadReady) {
			getMuxSignedUrl();
		}
	}, [getMuxSignedUrl, uploadReady]);

	const handleClickNewVideo = () => {
		setUploadReady(false);
		setValues((v) => ({ ...v, videoUploaded: false }));
	};

	const handleClickNext = async () => {
		nextStep();
	};

	const onUploadStart = async (e) => {
		const file = e?.detail?.file;
		if (!file || !file?.type?.startsWith("video/")) {
			notification.error({ message: "Invalid file type" });
			await getMuxSignedUrl();
			return false;
		}
		return true;
	};

	const afterUpload = (e) => {
		const file = e?.target?._upload?.file;

		if (file && file?.type?.startsWith("video")) {
			setUploadReady(true);
			setValues((v) => ({ ...v, videoUploaded: true }));
		}
	};

	return (
		<Flex vertical>
			<MuxUploadAndVideoPlayer
				loading={muxSignedUrlResponse?.isLoading}
				endpoint={muxSignedUrlResponse?.data?.url}
				onSuccess={afterUpload}
				videoUploaded={values?.videoUploaded}
				onUploadStart={onUploadStart}
				onUploadAgain={handleClickNewVideo}
			/>
			{values?.videoUploaded && (
				<Flex justify="center">
					<Button
						style={{ borderWidth: 1, marginTop: 16 }}
						className="primary-outlined--delete"
						onClick={handleClickNewVideo}
						type="button"
					>
						<EditOutlined />
						Change Workout Video
					</Button>
				</Flex>
			)}
			<div style={{ marginTop: 16 }} className="sb-workout-music-form__actions">
				<Button className="cancel-btn" size="small" type="button" onClick={() => previousStep()}>
					Previous
				</Button>

				<Button
					type="submit"
					onClick={handleClickNext}
					className="sb-upload-assets-form__form__button primary-filled"
					loading={loading}
					disabled={loading || !values?.videoUploaded}
				>
					Next
				</Button>
			</div>
		</Flex>
	);
};

export default PreRecordVideoUpload;

